module.exports = __webpack_public_path__ + "img/gate_skipped_badge.c38daf5.svg";